import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { delay } from "rxjs/operators";
import { EditorLayout } from "../../../../insa-models/editor-layout.model";

@Injectable()
export class EditorLayoutService {
    public createLayout(metadataName: string, layout) {
        const key = `${metadataName}/editorLayouts`
        let existingLayouts: EditorLayout[] = JSON.parse(localStorage.getItem(key));
        const layouts = existingLayouts ? [...existingLayouts, layout] : [layout]
        localStorage.setItem(key, JSON.stringify(layouts));
        return of(true).pipe(delay(500));;
    }

    public readLayouts(metadataName: string) {
        const key = `${metadataName}/editorLayouts`
        return of(JSON.parse(localStorage.getItem(key)) || []).pipe(delay(500)) as Observable<EditorLayout[]>;
    }

    public updateLayout(metadataName: string, layout) {
        const key = `${metadataName}/editorLayouts`
        let existingLayouts = JSON.parse(localStorage.getItem(key));
        const layouts = [...existingLayouts.filter(lyt => lyt.name !== layout.name), layout];
        localStorage.setItem(key, JSON.stringify(layouts));
        return of(true).pipe(delay(500));
    }

    public deleteLayout(metadataName: string, layoutName) {
        const key = `${metadataName}/editorLayouts`
        let existingLayouts = JSON.parse(localStorage.getItem(key));
        const layouts = existingLayouts.filter(lyt => lyt.name !== layoutName);
        localStorage.setItem(key, JSON.stringify(layouts));
        return of(true).pipe(delay(500));
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/services/editor-layout.service.ts